(function($) {
    $.fn.p5fwAccessibility = function(option, value) {
        var selector = $(this);

        var plugin = {
            normalContrast: 1,
            defaults: {
                tags: [ 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'p', 'a', 'span', 'strong', 'em', 'ul', 'ol', 'li' ],
                step: 3,
                container: '#p5fw-accessibility',
                menuSelector: '#p5fw-a-menu',
                menusSelector: '#p5fw-a-menus',
                increaseSelector: '#p5fw-a-increase',
                decreaseSelector: '#p5fw-a-decrease',
                normalSelector: '#p5fw-a-reset-font',
                contrastSelector: '#p5fw-a-contrast',
                librasSelector: '#p5fw-a-libras',
                resetSelector: '#p5fw-a-reset'
            },
            currentRatio: 0,
            options: {},
            affectedTags: new Array(),
            mergeOptions: function(option) {
                $.extend(this.options, this.defaults, option);
            },
            fetchTags: function() {
                /* Fetching all tags to work */
                var affectedTags = this.affectedTags;
                var options = this.options;
                $.each(this.options.tags, function(i, v) {
                    affectedTags.push(options.container + ' ' + v);
                });
            },
            storeDefaults: function() {
                /* Store default values for each elements */
                $.each(this.affectedTags, function(elIndex, elValue) {
                    $(elValue).each(function() {
                        var current_tag = $(this);
                        var font_size = current_tag.css('font-size');

                        if (font_size.indexOf('%') > -1) {
                            /* Percentage */
                            current_tag.data('originalSize', parseInt(font_size.replace('%', '')));
                            current_tag.data('originalUnit', '%');
                        } else {
                            /* Other units */
                            current_tag.data('originalSize', parseInt(font_size.replace(font_size.substr(-2), '')));
                            current_tag.data('originalUnit', font_size.substr(-2));
                        }

                        // current_tag.data('originalBackground', current_tag.css('background-color'));
                        // current_tag.data('originalColor', current_tag.css('color'));
                    });
                });

                /* Container default values */
                // $(this.options.container).data('originalBackground', $(this.options.container).css('background-color'));
                // $(this.options.container).data('originalColor', $(this.options.container).css('color'));
            },
            setActions: function() {
                var self = this;

                /* Decrease font size */
                selector.find(this.options.decreaseSelector).click(function(ev) {
                    ev.preventDefault();
                    self.decreaseFont();
                });

                // /* Reset font size */
                // selector.find(this.options.normalSelector).click(function(ev) {
                // 	ev.preventDefault();
                // 	self.resetFont();
                // });
                $(document).click(function(event) {
                    if ($('#p5fw-a-menus').css('display') == 'block') {
                        $('#p5fw-a-menus').hide();
                    }
                });

                /* Open Menu */
                selector.find(this.options.menuSelector).click(function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    self.menuChange();
                });

                /* Reset all */
                selector.find(this.options.resetSelector).click(function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    self.resetAll();
                });

                /* Increase font size */
                selector.find(this.options.increaseSelector).click(function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    self.increaseFont();
                });

                /* Change text contrast */
                selector.find(this.options.contrastSelector).click(function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    self.changeContrast();
                });

                /* Libras */
                selector.find(this.options.librasSelector).click(function(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    // self.changeContrast();
                    // $('div[vw-access-button]').click();
                });
            },
            decreaseFont: function() {
                let lenght = this.currentRatio - this.options.step;
                if (lenght >= 0) {
                    this.currentRatio = this.currentRatio - Math.abs(this.options.step);
                }
                this.changeFontSize();
            },
            increaseFont: function() {
                if (this.currentRatio + this.options.step <= 12) {
                    this.currentRatio = this.currentRatio + this.options.step;

                    $(this.options.increaseSelector).find(`.p-a-b-m-m-font-${this.currentRatio}`).addClass(`p-a-b-m-m-font-active`);
                } else {
                    $(this.options.increaseSelector).find(`.p-a-b-m-m-font`).removeClass(`p-a-b-m-m-font-active`);

                    this.currentRatio = 0;
                }

                this.changeFontSize();
            },
            // resetFont: function() {
            // 	/* Set default ratio */
            // 	this.currentRatio = 0;
            // 	this.changeFontSize();
            // 	$(this.options.increaseSelector).find(`.p-a-b-m-m-font`).removeClass(`p-a-b-m-m-font-active`);
            // },
            changeFontSize: function() {
                var current_ratio = this.currentRatio;

                $.each(this.affectedTags, function(elIndex, elValue) {
                    $(elValue).each(function() {
                        var current_tag = $(this);

                        current_tag.css('font-size', current_tag.data('originalSize') + current_ratio + current_tag.data('originalUnit'));
                    });
                });
            },
            changeContrast: function() {
                var normalContrast = this.normalContrast;

                this.resetContrast();

                let filterVal;

                if (normalContrast === 1) {
                    filterVal = 'invert(100%)';
                    this.normalContrast = 2;
                    this.changeMenuContrast();
                } else if (normalContrast === 2) {
                    filterVal = 'grayscale(100%)';
                    this.normalContrast = 3;
                    this.changeMenuContrast();
                } else if (normalContrast === 3) {
                    filterVal = 'hue-rotate(90deg)';
                    this.normalContrast = 4;
                    this.changeMenuContrast();
                } else if (normalContrast === 4) {
                    filterVal = 'none';
                    this.normalContrast = 1;
                    this.changeMenuContrast();
                }

                $('html').css('filter', filterVal).css('webkitFilter', filterVal).css('mozFilter', filterVal).css('oFilter', filterVal).css('msFilter', filterVal);

                // $(this.affectedTags.join(',')).each(function() {
                // 	let current_tag = $(this);
                // 	current_tag
                // 		.css('filter', filterVal)
                // 		.css('webkitFilter', filterVal)
                // 		.css('mozFilter', filterVal)
                // 		.css('oFilter', filterVal)
                // 		.css('msFilter', filterVal);
                // });
            },
            resetContrast: function() {
                this.normalContrast = 1;
                $('html').css('filter', 'none').css('webkitFilter', 'none').css('mozFilter', 'none').css('oFilter', 'none').css('msFilter', 'none');
            },
            changeMenuContrast: function() {
                if (this.normalContrast == 1) {
                    $(this.options.contrastSelector).find(`.p-a-b-m-m-contrast`).removeClass(`p-a-b-m-m-contrast-active`);
                } else {
                    $(this.options.contrastSelector).find(`.p-a-b-m-m-contrast-${this.normalContrast}`).addClass(`p-a-b-m-m-contrast-active`);
                }
            },

            resetAll: function() {
                // this.resetFont();
                this.resetContrast();

                this.currentRatio = 0;
                this.changeFontSize();
                $(this.options.increaseSelector).find(`.p-a-b-m-m-font`).removeClass(`p-a-b-m-m-font-active`);

                $(this.options.contrastSelector).find(`.p-a-b-m-m-contrast`).removeClass(`p-a-b-m-m-contrast-active`);
            },
            menuChange: function() {
                $(this.options.menusSelector).toggle();
            },
            startPlugin: function(option) {
                this.mergeOptions(option);
                this.fetchTags();
                this.storeDefaults();
                this.setActions();
            }
        };

        plugin.startPlugin(option);
    };
})(jQuery);
